import React from "react";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { UnderReviewResales } from "@pages/dashboard/UnderReviewResales";

const UnderReviewResalesComponent = () => {
  const { participantId } = useTypedParams(ROUTES.Profile.AccountDetails);

  return (
    <div className="pt-5">
      <h4>Under Review Resales</h4>
      <UnderReviewResales displayBanner={false} vendorId={participantId} />
    </div>
  );
};

export default UnderReviewResalesComponent;
